import { useEffect, useState } from 'react';
import {
    IconButton,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverArrow,
    Box,
    Grid,
    Text,
} from "@chakra-ui/react";
import { MdApps } from "react-icons/md";
import toast from 'react-hot-toast';
import { createAPIEndPoint } from 'config/api/api';

const AppMenu = () => {
    let token = typeof localStorage !== 'undefined' && localStorage.getItem('access_token');
    const [isOpen, setIsOpen] = useState(false);
    const handleToggle = () => setIsOpen(!isOpen);
    const user = JSON.parse(localStorage.getItem('user_profile'));
    const userId = user?.id ?? null;

    const [apps, setApps] = useState([]);

    const fetchUserApps = async () => {
        try {
            const response = await createAPIEndPoint('user_dashboards/').fetchById(userId);
            const filteredDashboards = response.data.dashboards.filter(
                (dashboard) => dashboard.name !== "auth"
            );
            setApps(filteredDashboards || []);
        } catch (err) {
            console.log(err?.response?.data?.error || 'Error fetching dashboards');
        }
    };

    useEffect(() => {
        if (userId) {
            fetchUserApps();
        }
    }, [userId]);

    const redirectToDashboard = async (url) => {
        try {
            if (url) {
                const redirectURL = `${url}?token=${token}`;
                window.open(redirectURL, '_blank');
            } else {
                console.error('No redirect URL found in response');
            }
        } catch (err) {
            toast.error(err?.response?.data?.error || 'Error fetching dashboards');
        }
    };

    return (
        <Box display="flex" alignItems="center">
            <Popover
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                placement="bottom-start"
                offset={[0, 5]}
            >
                <PopoverTrigger>
                    <IconButton
                        icon={<MdApps size={24} />}
                        onClick={handleToggle}
                        size="lg"
                        variant="solid"
                        color="brand.500"
                    />
                </PopoverTrigger>

                <PopoverContent
                    borderRadius="xl"
                    p={0}
                    w={{ base: "270px", md: "300px" }}
                    maxW="90vw"
                    border="1px solid"
                    borderColor="gray.200"
                    bg="white"
                    boxShadow="xl"
                    _focus={{
                        outline: "none",
                        boxShadow: "xl"
                    }}
                >
                    <PopoverArrow
                        bg="white"
                        borderColor="gray.600"
                        // boxShadow="none"
                    />

                    <Box p={{ base: 2, md: 4 }}>

                        <Grid
                            templateColumns={{ base: "repeat(3, 1fr)", md: "repeat(3, 1fr)" }}
                            gap={{ base: 2, sm: 3 }}
                        >
                            {apps.map((app, index) => (
                                <Box
                                    key={index}
                                    textAlign="center"
                                    onClick={() => {
                                        redirectToDashboard(app.dashboard_url);
                                        setIsOpen(false);
                                    }}
                                    cursor="pointer"
                                    p={{ base: 2, sm: 2.5 }}
                                    borderRadius="lg"
                                    transition="all 0.2s"
                                    _hover={{
                                        bg: "gray.50",
                                        transform: "translateY(-2px)",
                                    }}
                                    _active={{
                                        transform: "translateY(0)",
                                    }}
                                >
                                    <Box
                                        w={{ base: "36px", sm: "40px" }}
                                        h={{ base: "36px", sm: "40px" }}
                                        borderRadius="lg"
                                        bg="brand.500"
                                        color="white"
                                        fontWeight="bold"
                                        fontSize={{ base: "md", sm: "lg" }}
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        margin="0 auto"
                                        textTransform="uppercase"
                                    >
                                        {app?.name?.charAt(0) || '?'}
                                    </Box>
                                    <Text
                                        fontSize={{ base: "2xs", sm: "xs" }}
                                        color="gray.600"
                                        fontWeight="500"
                                        textTransform="capitalize"
                                        mt={{ base: 1.5, sm: 2 }}
                                        noOfLines={1}
                                    >
                                        {app?.name || 'Unknown'}
                                    </Text>
                                </Box>
                            ))}
                        </Grid>

                        {apps.length === 0 && (
                            <Box
                                textAlign="center"
                                py={8}
                                color="gray.500"
                            >
                                <Text fontSize="sm">No apps available</Text>
                            </Box>
                        )}
                    </Box>
                </PopoverContent>
            </Popover>
        </Box>
    );
};

export default AppMenu;

// import { useEffect, useState } from 'react';
// import {
//     IconButton,
//     Popover,
//     PopoverTrigger,
//     PopoverContent,
//     Box,
//     Grid,
//     Text,
// } from "@chakra-ui/react";
// import { MdApps, MdAccountCircle, MdSearch, MdMap, MdEmail, MdCalendarToday, MdPlayCircle } from "react-icons/md";
// import toast from 'react-hot-toast';
// import { createAPIEndPoint } from 'config/api/api';


// const AppMenu = () => {
//     let token = typeof localStorage !== 'undefined' && localStorage.getItem('access_token');
//     const [isOpen, setIsOpen] = useState(false);
//     const handleToggle = () => setIsOpen(!isOpen);
//     const user = JSON.parse(localStorage.getItem('user_profile'));
//     const userId = user?.id ?? null;
//     console.log("🚀 ~ AppMenu ~ userId:", userId)

//     const [apps, setApps] = useState([]);
//     console.log("AppMenu ~ apps:", apps)

//     const fetchUserApps = async () => {
//         try {
//             const response = await createAPIEndPoint('user_dashboards/').fetchById(userId);
//             const filteredDashboards = response.data.dashboards.filter(
//                 (dashboard) => dashboard.name !== "auth"
//             );

//             setApps(filteredDashboards || []);
//         } catch (err) {
//             console.log(err?.response?.data?.error || 'Error fetching dashboards');
//         }
//     };

//     useEffect(() => {
//         if (userId) {
//             fetchUserApps();
//         }
//     }, [userId]);



//     const redirectToDashboard = async (url) => {
//         try {
//             if (url) {
//                 const redirectURL = `${url}?token=${token}`;
//                 window.open(redirectURL, '_blank');
//             } else {
//                 console.error('No redirect URL found in response');
//             }
//         } catch (err) {
//             toast.error(err?.response?.data?.error || 'Error fetching dashboards');
//         }
//     };

//     return (
//         <Box display="flex" alignItems="center">
//             <Popover
//                 isOpen={isOpen}
//                 onClose={() => setIsOpen(false)}
//                 placement="bottom-start"
//             >
//                 <PopoverTrigger>
//                     <IconButton
//                         icon={<MdApps size={24} />}
//                         onClick={handleToggle}
//                         size="lg"
//                         variant="solid"
//                         color="brand.500"
//                     />
//                 </PopoverTrigger>

//                 <PopoverContent
//                     borderRadius="lg"
//                     p={0.5}
//                     _before={{
//                         content: '""',
//                         position: "absolute",
//                         top: 0,
//                         right: 0,
//                         bottom: 0,
//                         left: 0,
//                         zIndex: -1,
//                         borderRadius: "12px",
//                         margin: "-2px",
//                         background: "linear-gradient(to right, #6ea8e7, #007AFF)",
//                     }}
//                     w="300px"
//                     border="px solid transparent"
//                     bg="white"
//                     position="relative"

//                 >
//                     <Box sx={{
//                         backgroundColor: "white", borderRadius: "8px", p: 4
//                     }}>
//                         <Grid templateColumns="repeat(3, 1fr)" gap={4} justifyContent="center">
//                             {apps.map((app, index) => (
//                                 <Box key={index} textAlign="center">
//                                     <div onClick={() => redirectToDashboard(app.dashboard_url)} style={{ cursor: 'pointer' }} className='animate-apps'>
//                                         {app?.image === "image" ? (
//                                             <img
//                                                 src={app.image}
//                                                 alt={app.name}
//                                                 style={{
//                                                     width: '30px',
//                                                     height: '30px',
//                                                     borderRadius: '50%',
//                                                     margin: '0 auto',
//                                                     objectFit: 'contain',
//                                                 }}
//                                             />
//                                         ) : (
//                                             <Box
//                                                 w="30px"
//                                                 h="30px"
//                                                 borderRadius="50%"
//                                                 bg="gray.400"
//                                                 color="white"
//                                                 fontWeight="bold"
//                                                 display="flex"
//                                                 alignItems="center"
//                                                 justifyContent="center"
//                                                 margin="0 auto"
//                                                 textTransform="uppercase"
//                                                 textDecoration="none"
//                                             >
//                                                 {app?.name?.charAt(0) || '?'}
//                                             </Box>
//                                         )}
//                                         <Text fontSize="sm" color="#8F9BBA" fontWeight="500" textTransform="capitalize" mt={1}>
//                                             {app?.name || 'Unknown'}
//                                         </Text>
//                                     </div>
//                                 </Box>
//                             ))}

//                         </Grid>
//                     </Box>
//                 </PopoverContent>
//             </Popover>
//         </Box>
//     );
// };

// export default AppMenu;
